/* Replaces cart line images with the Petart composited preview when present. */
(function () {
  "use strict";

  var PREVIEW_KEYS = ["_petart_preview", "Preview"];

  function previewFromProperties(properties) {
    if (!properties) return "";
    for (var index = 0; index < PREVIEW_KEYS.length; index += 1) {
      var value = properties[PREVIEW_KEYS[index]];
      if (value && /^https?:\/\//i.test(value)) return value;
    }
    return "";
  }

  function setImage(image, url) {
    if (!image || !url) return;
    image.removeAttribute("srcset");
    image.removeAttribute("sizes");
    image.src = url;
    image.setAttribute("data-petart-cart-swapped", "true");
  }

  function findLineImages(lineNumber) {
    var selectors = [
      "#CartDrawer-Item-" + lineNumber + " .cart-item__image",
      "#CartItem-" + lineNumber + " .cart-item__image",
      '[id="CartDrawer-Item-' + lineNumber + '"] img.cart-item__image',
      '[id="CartItem-' + lineNumber + '"] img.cart-item__image',
    ];
    var nodes = [];
    selectors.forEach(function (selector) {
      Array.prototype.slice.call(document.querySelectorAll(selector)).forEach(function (node) {
        if (nodes.indexOf(node) === -1) nodes.push(node);
      });
    });
    return nodes;
  }

  function applyFromCart(cart) {
    if (!cart || !cart.items) return;
    cart.items.forEach(function (item, index) {
      var url = previewFromProperties(item.properties);
      if (!url) return;
      findLineImages(index + 1).forEach(function (image) {
        setImage(image, url);
      });
      // Cart notification / drawers that only expose a single product image.
      Array.prototype.slice
        .call(document.querySelectorAll("#cart-notification-product img, .cart-notification-product img"))
        .forEach(function (image) {
          if (image.getAttribute("src") && image.getAttribute("src").indexOf(String(item.id)) !== -1) {
            setImage(image, url);
          }
        });
    });
  }

  var pending = null;
  function refreshCartPreviews() {
    if (pending) return pending;
    pending = fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (response) {
        if (!response.ok) throw new Error("cart " + response.status);
        return response.json();
      })
      .then(applyFromCart)
      .catch(function () {
        /* cart page may be empty / offline */
      })
      .then(function () {
        pending = null;
      });
    return pending;
  }

  function boot() {
    refreshCartPreviews();
    document.addEventListener("cart:updated", refreshCartPreviews);
    document.addEventListener("cart:refresh", refreshCartPreviews);
    document.addEventListener("cart:build", refreshCartPreviews);

    // Dawn re-renders the drawer/items via section HTML after add-to-cart.
    var observer = new MutationObserver(function () {
      window.clearTimeout(observer._petartTimer);
      observer._petartTimer = window.setTimeout(refreshCartPreviews, 80);
    });
    ["cart-drawer", "#CartDrawer", "#main-cart-items", "cart-notification", "#cart-notification"].forEach(
      function (selector) {
        var node = document.querySelector(selector);
        if (node) observer.observe(node, { childList: true, subtree: true });
      },
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
